import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import data from '../../content/content.json'
import { Link, useI18next } from "gatsby-plugin-react-i18next"
import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import logoAnimation from '../../images/animations/logo_blanco.json'

// Desestructurar las propiedades para evitar warnings de webpack
const { styles } = data;
const { colors, breakpoints } = styles;
// El JSON se serializa una sola vez y se pasa por `data` (bundleado, sin fetch en runtime → sin 404 posible)
const logoData = JSON.stringify(logoAnimation)
const darkLogo = require('../../images/logo_blanco.png')
const lightLogo = require('../../images/logo_blanco.png')
const lightIconToggler = require('../../images/icon_toggler.svg')
const darkIconToggler = require('../../images/icon_toggler_dark.svg')
const iconTogglerClose = require('../../images/icon_toggler_close.svg')

const NavWrapper = styled.nav`
    width: 100%;
    position: fixed;
    background-color: ${props => props.ishomepage === "true" ? colors.white : colors.purplePrimary};
    display: flex;
    padding: 8px 20px;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    @media (min-width: ${breakpoints.xl}px) {
        padding: 16px 150px;
    }
`
const LinkLogo = styled(Link)`
    display: flex;
    align-items: center;
    @media (min-width: ${breakpoints.xl}px) {
        order: 1;
    }
`
// Caja del logo: dimensiones fijas para evitar saltos de layout entre el PNG y el Lottie
const LogoBox = styled.div`
    position: relative;
    width: 120px;
    height: 40px;
    @media (min-width: ${breakpoints.xl}px) {
        width: 210px;
        height: 66px;
    }
`
// Fallback estático: siempre presente desde el HTML (aparece al instante), se desvanece cuando el Lottie está listo
const Logo = styled.img`
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100px;
    height: 21px;
    display: block;
    transition: opacity .25s ease;
    opacity: ${props => props.faded ? 0 : 1};
    @media (min-width: ${breakpoints.xl}px) {
        width: 200px;
        height: 43px;
    }
`
// Canvas animado: superpuesto, aparece con fade cuando dispara el evento load
const LogoCanvas = styled.div`
    position: absolute;
    inset: 0;
    opacity: ${props => props.visible ? 1 : 0};
    transition: opacity .25s ease;
    canvas {
        width: 100% !important;
        height: 100% !important;
        display: block;
    }
`
const LangSelector = styled.nav`
    border: 2px solid ${props => props.ishomepage === "true" ? colors.purplePrimary : colors.white};
    margin-right: auto;
    margin-left: auto;
    padding: 7px 10px;
    border-radius: 47px;
    max-width: 88px;
    max-height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (min-width: ${breakpoints.xl}px) {
        order: 3;
        margin-right: unset;
        margin-left: 0;
    }
`
const LangItem = styled.li`
    list-style-type: none;
    border-radius: 100%;
    background-color: ${props => props.isSelected ? colors.yellow : colors.transparent};
    &:first-of-type {
        margin-right: 5px;
    }
`
const Lang = styled(Link)`
    text-decoration: none;
    padding: 5px 6px;
    display: block;
`

const NavToggler = styled.button`
    width: 32px;
    height: 30px;
    margin-left: auto;
    background: none;
    border: 0;
    box-shadow: 0;
    cursor: pointer;
    @media (min-width: ${breakpoints.xl}px) {
        display: none;
    }
`
const NavTogglerIcon = styled.img`
    width: 32px;
    height: 30px;
`
const NavTogglerClose = styled.button`
    width: 32px;
    height: 30px;
    margin-left: auto;
    background: none;
    border: 0;
    box-shadow: 0;
    cursor: pointer;
    @media (min-width: ${breakpoints.xl}px) {
        display: none;
    }
`
const NavTogglerCloseIcon = styled.img`
    width: auto;
    height: 30px;
    margin-left: auto;
`
const MainNavContainer = styled.div`
    width: 100%;
    height: 100vh;
    background: ${colors.white};
    position: absolute;
    top: 0;
    left: 0; 
    flex-wrap: wrap;
    flex-direction: column;
    padding: 16px 18px;
    display: ${props => props.isNavOpen ? 'flex' : 'none'};
    @media (min-width: ${breakpoints.xl}px) {
        width: unset;
        height: unset;
        background: ${colors.transparent};
        position: static;
        display: block;
        padding: 0;
        order: 2;
        margin-left: auto;
    }
`
const MainNav = styled.nav`
    margin: 50px auto;
    width: 100%;
    @media (min-width: ${breakpoints.xl}px) {
        margin: 0;
        ul li a {
        color: ${props => props.ishomepage === "true"? colors.darkMainBg : colors.white};
        }
    }
`
const NavLinks = styled.ul`
    text-align: center;
    @media (min-width: ${breakpoints.xl}px) {
        display: flex;
        flex-direction: row;
    }
`
const NavItem = styled.li`
    list-style-type: none;
    margin: 0 0 17px 0;
    @media (min-width: ${breakpoints.xl}px) {
        margin: 0 30px 0 0;
        &:last-of-type {
            margin-right: 21px;
        }
    }
`
const NavLink = styled(Link)`
    text-decoration: none;
    font-size: 1.44em;
    font-weight:${styles.fontWeight.bold};    
    display: block;
    color: ${colors.purplePrimary};
    &:visited {
        ${colors.purplePrimary};
    }
    &:hover,
    &:active{
        color: ${colors.yellow}!important;
    }
    ${props => props.active ? `color: ${colors.yellow}!important;` : '' }
    @media (min-width: ${breakpoints.xl}px) {
        color: ${colors.darkMainBg};
        text-transform: uppercase;
    }
`

const LangContent = styled.abbr`
    text-decoration: none;
    text-transform: uppercase;
    font-size: 1em;
    font-weight:${styles.fontWeight.bold};
    color: ${props => {
        if ((props.ishomepage === "true" && !props.isSelected) || (props.ishomepage === "false" && props.isSelected) || props.isSelected) {
            return colors.purplePrimary
        } else {
            if ((props.ishomepage === "false" && !props.isSelected)) {
                return colors.white
            } else {
                return colors.purplePrimary
            }
        }
    }
    };
    `

const Header = (props) => {
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [activeLink, setActiveLink] = useState('/');
    const [logoReady, setLogoReady] = useState(false);
    const { t, languages, language, originalPath } = useI18next();
    // Revela el canvas (y desvanece el PNG) recién cuando la animación cargó y está lista
    const dotLottieRefCallback = (dotLottie) => {
        if (!dotLottie) return;
        dotLottie.addEventListener('load', () => setLogoReady(true));
    }
    const languageNames = {
        "en": "English",
        "es": "Español"
    }
    useEffect(() => {
        let active;
        props.menuLinks.forEach(menuLink => {
           if (menuLink.link !== '/' && props.location.pathname.includes(menuLink.link.toLowerCase())) {
                active = menuLink.link;
            } 
        });
        if (!active) active = '/';

        setActiveLink(active)

    }, [props.location.pathname, props.menuLinks])

    return (
        <NavWrapper ishomepage={props.ishomepage}>
            <LinkLogo to="/">
                <LogoBox>
                    <Logo
                        src={(props.ishomepage === "true" ? darkLogo : lightLogo).default}
                        alt={t("header.logoAlt")}
                        faded={logoReady}
                    />
                    <LogoCanvas visible={logoReady}>
                        <DotLottieReact
                            data={logoData}
                            autoplay
                            dotLottieRefCallback={dotLottieRefCallback}
                        />
                    </LogoCanvas>
                </LogoBox>
            </LinkLogo>
            
            <LangSelector ishomepage={props.ishomepage}>
                {languages.map((lang) => (
                    <LangItem
                        key={lang}
                        isSelected={language === lang}
                    >
                        <Lang to={originalPath || "/"} language={lang}>
                            <LangContent 
                                isSelected={language === lang} 
                                ishomepage={props.ishomepage} 
                                lang={lang} 
                                title={languageNames[lang]}>
                                {lang}
                            </LangContent>
                        </Lang>
                    </LangItem>
                ))}
            </LangSelector>
            <NavToggler onClick={() => {setIsNavOpen(true)}}>
                {
                    props.ishomepage === "true" ? 
                    <NavTogglerIcon src={lightIconToggler.default} alt={t("header.iconTogglerAlt")} />
                    : <NavTogglerIcon src={darkIconToggler.default} alt={t("header.iconTogglerAlt")} />
                }
            </NavToggler>
            <MainNavContainer isNavOpen={isNavOpen} >
                <NavTogglerClose onClick={() => {setIsNavOpen(false)}}>
                    <NavTogglerCloseIcon src={iconTogglerClose.default} alt={t("header.iconTogglerCloseAlt")} />
                </NavTogglerClose>
                <MainNav ishomepage={props.ishomepage}>
                    <NavLinks>
                        {
                            props.menuLinks && props.menuLinks.map((menuLink)=> {
                                return (
                                    <NavItem key={menuLink.name} onClick={() => {setIsNavOpen(false)}}>
                                        <NavLink className="navbar-item" to={menuLink.link} active={activeLink === menuLink.link ? 1 : 0}>
                                            {t(menuLink.name)}
                                        </NavLink>
                                    </NavItem>)
                                })
                        }     
                    </NavLinks>
                </MainNav>
            </MainNavContainer>
        </NavWrapper>
    );
};

export default Header;
